// extracted by mini-css-extract-plugin
export default {"betButton":"BetButton_betButton__pRjXI","betButton--active":"BetButton_betButton--active__-oRrd"};